import { render, staticRenderFns } from "./detailmonitoring.vue?vue&type=template&id=68dd13be"
import script from "./detailmonitoring.vue?vue&type=script&lang=js"
export * from "./detailmonitoring.vue?vue&type=script&lang=js"
import style0 from "./detailmonitoring.vue?vue&type=style&index=0&id=68dd13be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports